import { InputValidator } from "../inputvalidator";
import { phonenumberHolder } from "../phonenumber";

const input = document.querySelector("#phonenumber") as HTMLInputElement;
const errorMsg = document.querySelector("#telError") as HTMLElement;
const registrationStep2 = "registration-form";

const inputValidation = new InputValidator("login-form");

const phonenumber = new phonenumberHolder(
    input,
    errorMsg,
    registrationStep2,
    true
);

$(`#${registrationStep2}`).on("submit", function (this: HTMLFormElement, e: JQuery.TriggeredEvent) {
    if (phonenumber.error || !phonenumber.iti.isValidNumber())
        e.preventDefault();
});
